<template>
  <b-card class="text-center">
    <template #header>
      Kudos
    </template>
    <p class="p-5 m-0">
      How kudos work in {{AppName}}?
    </p>
    <template #footer>
      <div class="mb-3">
        <b-button variant="primary" class="w-max-200 w-100" @click="modalShow = !modalShow">
          Learn
        </b-button>
      </div>
    </template>
    <b-modal v-model="modalShow" hide-header hide-footer size="lg" content-class="bg-color-darkgray">
      <kudo-instructions />
    </b-modal>
  </b-card>
</template>

<script>
import KudoInstructions from '@/components/KudoInstructions'
import { AppName } from '@/helpers/constants'

export default {
  name: 'HowKudosWork',

  data() {
    return {
      AppName,
      modalShow: false
    }
  },

  components: {
    KudoInstructions
  }
}
</script>
